const URLS = {
  mapionBaseUrl: process.env.REACT_APP_BASE_URL,

  // キョリ測URL
  kyorisokuUrl: `${process.env.REACT_APP_BASE_URL}${process.env.PUBLIC_URL}/route`,

  weatherPageUrl: (prefCodeStr, cityCodeStr) =>
    `${process.env.REACT_APP_MAPION_WEATHER_URL}/${prefCodeStr}/${cityCodeStr}.html`,

  // メニュー内のリンク
  menu: {
    // アップデートしました
    updateNotice: 'https://help.mapion.co.jp/smp/webview/mapion_202603_renewal.html',
    // ヘルプ
    help: 'https://help.mapion.co.jp/smp/webview/help_202603.html#basic',
    // お問い合わせ
    inquiry: 'https://www.mapion.co.jp/smp/help/inquiry/',
    // マイページ（保存済みスポット）
    myPage: `${process.env.REACT_APP_BASE_URL}/smp/member/`,
    // ログアウト
    logout: `${process.env.REACT_APP_BASE_URL}/account/logout_service/`,
    // ログイン
    login: `${process.env.REACT_APP_BASE_URL}/account/login/`,

    // 日本地図
    japanMap: `${process.env.REACT_APP_BASE_URL}/smp/map/japan.html`,
    // 住所検索
    addressSearch: `${process.env.REACT_APP_BASE_URL}/smp/address/`,
    // 駅検索
    stationSearch: `${process.env.REACT_APP_BASE_URL}/smp/station/`,
    // 郵便番号検索
    zipSearch: `${process.env.REACT_APP_BASE_URL}/smp/zip/`,
    // 鉄道乗換案内
    transit: `${process.env.REACT_APP_BASE_URL}/smp/transit/`,
    // 時刻表
    timetable: `${process.env.REACT_APP_BASE_URL}/smp/transit/timetable/`,
    // 電話帳
    phonebook: `${process.env.REACT_APP_BASE_URL}/smp/phonebook/`,
    // 天気
    weather: `${process.env.REACT_APP_BASE_URL}/smp/weather/`,
    // ニュース
    news: `${process.env.REACT_APP_BASE_URL}/smp/news/`,
    // 観光マップ
    touristMap: `${process.env.REACT_APP_BASE_URL}/d/tourist-map/`,

    // アプリ一覧
    apps: 'https://www.mapion.co.jp/d/topics/smp/',
    // サイトマップ
    sitemap: 'https://www.mapion.co.jp/QA/sitemap/sitemap.html',
    // 利用規約
    terms: 'https://help.mapion.co.jp/smp/info/terms.html',
    // 個人情報保護方針
    privacyPolicy: 'https://onecompath.com/privacy',
    // 個人情報の取り扱い
    personalInfoHandling: 'https://www.mapion.co.jp/f/privacy/',
    // 会社概要
    company: 'https://onecompath.com',
  },

  // アプリで見る用のリンク
  viewInApp: {
    iosUniversalLinkBase: 'https://d1qmg7ghawj2bv.cloudfront.net/ios/mapion_universal_link.html',
    androidStoreUrl: 'https://play.google.com/store/apps/details?id=jp.co.mapion.android.app.maps',

    // intent://{HOST_AND_PATH}?query...#Intent;scheme=...;package=...;end の形式で使う
    androidIntentHostAndPath: 'map3d/map',
    androidIntentScheme: 'mapionapp',
    androidPackage: 'jp.co.mapion.android.app.maps',
  }

};

export default URLS;
